import { CookieService } from '../../utility/cookie';
import * as $ from 'jquery';
import { UrlUtility } from '../../utility/url'
import { CardSectionService } from '../card-section/card-section-common';
import { HTML5Navigator } from '../../page-services/html5-navigator';
import { ProductsBreadCrumbs } from './products-breadcrumbs';
import { ProductsMeta } from './products-meta';
import { getProductSlug } from './product-slug.service';

declare global {
    interface JQuery {
        masonry(arg?): any,
        slick(arg?): any
    }
}


export namespace ProductsAZ {

    const FilterTimeout = 0.02; //save filter for half an hour
    let defaults: any = {};

    type ProductSort = 'alphabetical' | 'cms' | 'globalsort';
    type ProductView = 'cards' | 'list';

    interface ProductFilter {
        page?: number, category?: number, range?: string, sort?: ProductSort, view?: ProductView
    }

    export class ProductAZCommon {

        private static loading: boolean = false;
        private static products: Array<Product> = [];
        private static marketingCard: any = null;
        private static marketingCardPosition: number = 1;

        private static baseFilter: ProductFilter = { page: 1, category: 0, range: '', sort: 'globalsort', view: 'cards' };

        public static get filter(): ProductFilter {
            let f = ProductAZCommon.readPersistedFilter();
            return f || ProductAZCommon.baseFilter;
        }
        public static set filter(v: ProductFilter) {
            ProductAZCommon.persistFilter(v);
        }

        private static persistFilter(filter: ProductFilter) {
            CookieService.setCookie('product-filter', JSON.stringify(filter), FilterTimeout, '/');
        }

        private static readPersistedFilter() {
            let filter = CookieService.getCookie('product-filter');
            if (filter)
                return JSON.parse(filter);
            return null;
        }

        private static refresh = () => {

            let segments = location.pathname.split('/')
            let slug = segments.pop();
            let id = null;

            if (slug) {
                let el = $(segments.length == 3 ? `[data-subseourl="${slug}"]` : `[data-mainseourl="${slug}"]`).eq(0);
                if (el.length) {
                    let title = document.title
                    if (el.hasClass('main-category')) {
                        id = el.attr('data-maincategory');
                        title = el.attr('data-maincategory-name');
                        ProductsBreadCrumbs.refresh(title);
                    }
                    else {
                        id = el.attr('data-subcategory');
                        title = el.attr('data-subcategory-name')
                        ProductsBreadCrumbs.refresh(el.attr('data-maincategory-name'), el.attr('data-parentseourl'), title);
                    }

                    let metaTitle = el.attr('data-seo-title') || el.attr('data-seoTitle');
                    let metaDescription = el.attr('data-seo-description') || el.attr('data-seoDescription');

                    document.title = (title || metaTitle || defaults.title) +'!!!';
                    ProductsMeta.refresh(metaTitle, metaDescription);
                }
                else {
                    
                    document.title = defaults.title;
                    ProductsBreadCrumbs.refresh(defaults.metaTitle, defaults.metaDescription);
                    ProductsMeta.refresh(defaults.metaTitle, defaults.metaDescription);
                }
            }
            else {
                ProductsBreadCrumbs.refresh();
            }
            ProductAZCommon.filter = { ...(ProductAZCommon.filter), category: id };
            ProductAZUI.setUI(ProductAZCommon.filter.category);
            ProductAZCommon.getResult();
        }

        private static setUrl(mainCategory: string, subCategory?: string) {
            //window.location.replace(window.location.href.split('?')[0] + '?' + hashID + '_' + hashSeoUrl);

            let url = getProductSlug()
            if (mainCategory) url += `/${mainCategory}`;
            if (subCategory) url += `/${subCategory}`;
            HTML5Navigator.instance.navigate({}, defaults.title, url);
            //window.history.pushState({}, 'Baumit', window.location.href.split('?')[0] + '?category=' + hashSeoUrl);
            //ProductAZCommon.refresh();
        }

        private static urlChanged = () => setTimeout(ProductAZCommon.refresh, 200);

        // private static hookHistory() {
        //     const pushState = history.pushState;
        //     history.pushState = function (state) {
        //         ProductAZCommon.urlChanged();
        //         return pushState.apply(history, arguments);
        //     }
        //     window.onpopstate = ProductAZCommon.refresh;

        // }


        public static init() {
            //ProductAZCommon.hookHistory();
            if ($('[data-product-category-page]').length == 0) {
                return;
            }
            HTML5Navigator.instance.navigationEvent.subscribe(ProductAZCommon.urlChanged)
            ProductAZUI.init();
            defaults = {
                title: document.title,
                metaTitle: $('meta[name="title"]').attr('content'),
                metaDescription: $('meta[name="description"]').attr('content')
            }
            if (location.href.indexOf('search_results') > -1)
                ProductAZCommon.filter = ProductAZCommon.baseFilter;
            $(document).on('click', '.main-category[data-maincategory]', ev => {
                ev.preventDefault();
                if (this.loading) return;
                let target = $(ev.target).closest('.main-category');
                let category = parseInt(target.attr('data-maincategory'));
                let url = target.attr('data-mainseourl');
                ProductAZCommon.filter = { ...(ProductAZCommon.filter), page: 1, range: '', category: category, sort: 'globalsort' };
                ProductAZCommon.setUrl(url);
                ProductAZUI.scrollTop();
            });
            $(document).on('click', '.sub-category', ev => {
                ev.preventDefault();
                if (this.loading) return;
                let target = $(ev.target).closest('.sub-category');
                let category = parseInt(target.attr('data-subcategory'));
                ProductAZCommon.filter = { ...(ProductAZCommon.filter), page: 1, range: '', category: category, sort: 'cms' };
                ProductAZCommon.setUrl(target.attr('data-parentseourl'), target.attr('data-subseourl'));
                ProductAZUI.scrollTop();
            });
            $(document).on('click', '#reset', function () {
                ProductAZCommon.filter = ProductAZCommon.baseFilter;
                //window.history.replaceState({}, 'Baumit', window.location.href.split('?')[0]);
                ProductAZCommon.resetMenu();
                ProductAZCommon.filter = { ...(ProductAZCommon.filter), page: 1, range: '', category: -1, sort: 'globalsort' };
                HTML5Navigator.instance.navigate({}, 'Baumit', getProductSlug());
                //ProductAZCommon.getResult();
            });

            $(document).on('click', '.viewCards', function () {
                if (ProductAZCommon.loading) return;
                ProductAZCommon.filter = { ...(ProductAZCommon.filter), view: "cards" };
                ProductAZUI.gridView(ProductAZCommon.products,ProductAZCommon.marketingCard,ProductAZCommon.marketingCardPosition);
            });
            $(document).on('click', '.viewList', function () {
                if (ProductAZCommon.loading) return;
                ProductAZCommon.filter = { ...(ProductAZCommon.filter), view: "list" };
                ProductAZUI.listView(ProductAZCommon.products,ProductAZCommon.marketingCard,ProductAZCommon.marketingCardPosition);
            });
            $(document).on('click', '.products .filter-item.letter-filter', function () {
                if (ProductAZCommon.loading) return;
                $('.filter-item').removeClass('selected');
                $(this).addClass('selected');
                ProductAZCommon.filter = { ...(ProductAZCommon.filter), sort: 'alphabetical', range: $(this).attr('data-range'), page: 1 };
                ProductAZCommon.getResult();
            });
            $(document).on('click', '.page-link', function (ev) {
                ProductAZCommon.filter = { ...(ProductAZCommon.filter), page: parseInt($(this).attr('index')) };
                ProductAZCommon.getResult();
                if ($(ev.target).closest('.lc-pagination')) return;
                ProductAZUI.scrollTop();
            });
            ProductAZCommon.refresh();
        }


        private static getSearchResults(query) {
            $.ajax({
                url: '/ajaxProductSearchGetProducts?q=' + query + '&page=' + ProductAZCommon.filter.page,
            }).done(function (result) {
                ProductAZCommon.processResult(result,/* ProductAZCommon.baseFilter*/ProductAZCommon.filter)
            });
        }

        private static resetMenu() {
            $('.level-2 li').each(function (i, e) {
                var item = $(e);

                item.removeClass('opened');
                item.find('p').removeClass('selected');
                item.find('ul.main-category-menu').hide();
            });
        }

        private static getResult() {
            if ($('div[data="products-az"]').length == 0) return;
            if ($(['data-az-page']).length == 0)
                return;

            if (ProductAZCommon.loading) return;
            ProductAZCommon.loading = true;
            ProductAZUI.load();
            if (location.href.indexOf(`/${getProductSlug()}/search_results`) > -1) {
                let query = UrlUtility.getUrlParam(location.href, 'q');
                if (query) {
                    return ProductAZCommon.getSearchResults(query);
                }
            }

            let params = '?';
            let filter = ProductAZCommon.filter;
            if (filter.page) {
                params += 'page=' + filter.page + '&';
            }
            if (filter.category) {
                params += 'category=' + filter.category + '&';
            }
            if (filter.range && filter.range != '' && filter.range != 'ALL') {
                params += 'range=' + filter.range + '&';
            }
            if (filter.sort) {
                params += 'sort=' + filter.sort + '&';
                params = params.substr(0, params.length - 1);
            }

            $.ajax({
                url: '/ajaxGetProducts' + params,
            }).done(function (result) {
                ProductAZCommon.processResult(result, filter);
            });
        }

        private static processResult(result, filter) {
            ProductAZCommon.products = result.products.data;
            ProductAZUI.setTotal(result.products.total);
            ProductAZUI.paginator(result.products.last_page, filter);
            if (result.moreInromation)
                ProductAZUI.showMoreInformation(result.moreInformation, filter.view);
            //console.log(result, result.productCategory)
            if (result.productCategory) {
                document.title = result.productCategory.seo?.title || result.productCategory.name || result.productCategory;
            }
            if (result.productCategory){
                ProductAZUI.showProductCategoryData(result.productCategory);
            }
            else{
                ProductAZUI.hideProductCategoryData();
            } 
                
            if (result.ranges)
                ProductAZUI.filterRanges(result.ranges, filter.range);

            let marketingCard = result.marketingCard ? result.marketingCard : null;
            ProductAZCommon.marketingCard = marketingCard;
            let marketingCardPosition = result.marketingCardPosition ? result.marketingCardPosition : 1;
            ProductAZCommon.marketingCardPosition = parseInt(marketingCardPosition);
            ProductAZUI.loaded(result.products.data, filter.view,marketingCard,marketingCardPosition);
            ProductAZCommon.loading = false;
        }

    }

    export interface Product {
        assets: Array<{ URL: string, type_name: string }>,
        all_asset_download_url: string,
        card: { id: number, badge_eco: number, badge_new: number, badge_premium: number, image_seo_alt: string, image_seo_title: string },
        name: string,
        card_dashboard_icon_rendered: string,
        description: string,
        image: string,
        details_url: string,
        additional_name: string,
        alternative_name: string,
        product_benefit_1: string, 
        product_benefit_2: string, 
        product_benefit_3: string,
        categories: any[]
    }

    export class ProductAZUI {


        public static load() {
            $('.more-informations-container').hide();
            $('.counter').css('opacity', 0);
            $('.products-az').addClass('hidden');
            $('.pagination').hide();
            $('.loader').fadeIn();
            $('.filter, .left-menu').css('pointer-events', 'none');

        }

        public static loaded(products: Array<Product>, view: ProductView,marketingCard=null,marketingCardPosition=1) {
            $('.loader').fadeOut();
            $('.filter').fadeIn();
            $('.counter').animate({ 'opacity': 1 }, 400);
            if (view == 'list')
                ProductAZUI.listView(products,marketingCard,marketingCardPosition);
            else {
                ProductAZUI.gridView(products,marketingCard,marketingCardPosition);
            }
            $('.pagination').fadeIn();
            $('.filter, .left-menu').css('pointer-events', 'all');
        }


        public static scrollTop() {
            var body = $("html, body");
            body.stop().animate({ scrollTop: 0 }, 500, 'swing');
        }


        public static setUI(categoryId: number) {
            //if (location.href.indexOf('products-a-z') == -1) return;
            if ($('div[data="products-az"]').length == 0) return;

            let prevMnu = $('ul.level-2 li.opened').eq(0);
            prevMnu.removeClass('opened');
            // $('ul.level-3').removeClass('opened').slideUp();
            $('.left-menu p').removeClass('selected');
            //if (location.href.indexOf('/products/search_results') > -1) return;
            if ($('div[data="product-search-result"]').length == -1) return;

            let mnu = $('[data-subcategory="' + categoryId + '"]');
            let main;
            if (mnu.length > 0) {
                main = $('.main-category[data-maincategory="' + mnu.attr('data-maincategory') + '"]');
                main.closest('li').addClass('opened');
                mnu.find('p').addClass('selected');
            }
            else {
                main = $('.main-category[data-maincategory="' + categoryId + '"]');
            }
            main.find('p').addClass('selected');
            if (!main.closest('li').is(prevMnu)) {
                prevMnu.find('ul').slideUp();
                main.closest('li').addClass('opened');
                main.closest('li').find('ul').slideDown();
            }
            $('.page-title').html(mnu.text());

            $('.main-breadcrumb').removeClass('hidden').addClass('active').html('<span class="mdi mdi-chevron-right"></span>' + mnu.text());

        }


        public static gridView(products: Array<Product>,marketingCard=null,marketingCardPosition=1) {
            try {
                $('.viewCards').hide();
                $('.viewList').show();
                $('.accordion').addClass('hidden');
                $('.grid').removeClass('hidden');
                //$('.more-informations-container').show();
                ProductAZUI.buildGrid(products,marketingCard,marketingCardPosition);
            } catch (ex) { console.warn(ex) }
        }

        public static listView(products: Array<Product>,marketingCard=null,marketingCardPosition=1) {
            try {
                $('.viewList').hide();
                $('.viewCards').show();
                $('.accordion').removeClass('hidden');
                $('.grid').addClass('hidden');
                $('.more-informations-container').hide();
                ProductAZUI.buildAccordion(products,marketingCard,marketingCardPosition);
            } catch (ex) { console.warn(ex) }
        }

        private static buildAccordion(products: Array<Product>,marketingCard=null,marketingCardPosition=1) {
            $('.accordion, .grid').html('');
            products.forEach(function (product,index) {
                if(marketingCard != null && (index+1) == marketingCardPosition){
                    var marketingCardHtmlAccordion = "";
                    var ttl = marketingCard.title ? marketingCard.title : (marketingCard.cardable ? (marketingCard.cardable.name ? marketingCard.cardable.name : (marketingCard.cardable.title ? marketingCard.cardable.title : '-')) : '-') 
                    marketingCardHtmlAccordion = '<div class="accordion-item product product-list-marketing-card" data-card-id="' + marketingCard.id + '">'
                    + '<div class="accordion-title relative">'
                    + '<button class="toLeft"><h3>'
                    + '<span class="mdi mdi-chevron-down">'
                    + '</span>' + ttl + '</h3></button>'
                    + '<div class="extra"><i class="actionToggleDashboard material-icons " data-card-id="' + marketingCard.id + '" data-add-url="/myBaumit/ajaxAddCardToDashboard" data-delete-url="/myBaumit/ajaxDeleteCardFromDashboard" data-added-to-dashboard="0"> star_border  </i></div>';
                    marketingCardHtmlAccordion += '</div>'
                    + '<div class="accordion-detail product-detail">'
                    + '<div class="inner clearfix">'
                    + '<div class="toLeft detailed-text">'
                    + '<p class="alternative-name mb-1"></p>'
                    +(marketingCard.description ? '<p class="text-inner description">' + marketingCard.description + '</p>' : '')

                    marketingCardHtmlAccordion += '<img src="' + marketingCard.image + '" class="show-only-mobile">'
                    + '<p class="to-product"><a href="' + marketingCard.details_url +  '" title="">' + ttl + '</a></p>'
                    + '</div>'
                    + '<div class="marketing-card-image toRight">'
                    + '<img src="' + marketingCard.image + '" class="" alt="' + ttl + '" />'
                    + '</div>'
                    + '</div>'
                    + '</div>'
                    + '</div>';
                    $('.accordion').append(marketingCardHtmlAccordion);
                }
                var htmlAccordion = "";
                let assets = product.assets;
                let all_pdf = '';

                if (assets.length > 0) {
                    all_pdf = product.all_asset_download_url;
                }

                htmlAccordion = '<div class="accordion-item product" data-card-id="' + product.card.id + '">'
                    + '<div class="accordion-title relative">'
                    + '<button class="toLeft"><h3>'
                    + '<span class="mdi mdi-chevron-down">'
                    + '</span>' + product.name + '</h3></button>' + product.card_dashboard_icon_rendered + '<div class="extra sheets">'
                    + '<button class="extra-button material-icons ';

                if (assets.length == 0) {
                    htmlAccordion += 'disabled';
                }

                htmlAccordion += '">description</button><div class="extra-container box-shadow"><ul>';

                assets.forEach(function (file) {
                    htmlAccordion += '<li><i class="material-icons">get_app</i><a rel="noindex nofollow" href="' + file.URL + '" target="_blank">' + file.type_name + '</a></li>';
                });
                if (assets.length > 1) {
                    htmlAccordion += '<li><i class="material-icons">get_app</i><a rel="noindex nofollow" href="' + all_pdf + '" target="_blank">' + (self as any).translations.general_download_all + '</a></li>';
                }

                const categoryParam = ProductAZUI.getCategoryParam(product, ProductAZCommon.filter.category)

                htmlAccordion += '</ul>'
                    + '</div>'
                    + '</div>'
                    + '</div>'
                    + '<div class="accordion-detail product-detail">'
                    + '<div class="inner clearfix">'
                    + '<div class="toLeft detailed-text">'
                    + '<p class="alternative-name mb-1">' + product.alternative_name + '</p>'
                    + '<p class="description">' + product.description + '</p>'

                if ((self as any).useProductBenefitsOnProductCards) {
                    htmlAccordion += '<ul class="list-benefits">'
                        + product.product_benefit_1 ? '<li class="benefit">' + product.product_benefit_1 + '</li>' : ''
                        + product.product_benefit_2 ? '<li class="benefit">' + product.product_benefit_2 + '</li>' : ''
                        + product.product_benefit_3 ? '<li class="benefit">' + product.product_benefit_3 + '</li>' : ''
                        + '</ul>'
                    }
                    
                htmlAccordion += '<img src="' + product.image + '" class="show-only-mobile">'
                    + '<p class="to-product"><a href="' + product.details_url + ((categoryParam && categoryParam.length > 0) ? '?category=' + categoryParam : '') + '" title="">' + (self as any).translations.products_go_to_product + '</a></p>'
                    + '</div>'
                    + '<div class="image toRight">'
                    + '<img src="' + product.image + '" class="show-only-non-mobile" alt="'+ product.name +'">'
                    + '</div>'
                    + '</div>'
                    + '</div>'
                    + '</div>'

                $('.accordion').append(htmlAccordion);
            });
        }


        private static getCategoryParam(product: Product, category: number) {
            if (product.categories.length < 2) return '';
            const url = ProductAZUI.getMainSeoUrl(category);
            if (product.details_url.split('/').indexOf(url) > -1) return '';
            return url;
        }

        private static getMainSeoUrl(category) {
            let url = 'none';
            try {
                const el = $(`[data-maincategory="${category}"], [data-subcategory="${category}"]`);
                return (el.attr('data-mainseourl') || el.attr('data-subseourl'));

                //url = $('[data-maincategory=' + $(`[data-maincategory="${category}"], [data-subcategory="${category}"]`).attr('data-maincategory') + '].main-category').attr('data-mainseourl');
            }
            catch (ex) { }
            return url;
        }

        private static buildGrid(products: Array<Product>,marketingCard=null,marketingCardPosition=1) {
            if ($('.grid.products-az').length == 0) return;
            CardSectionService.cardsHeightFix($('.grid.products-az'));
            $('.accordion, .grid.products-az').html('');
            products.forEach(function (product,index) {
                if(marketingCard != null && (index+1) == marketingCardPosition){
                   var marketingHtmlGrid = '';
                    marketingHtmlGrid = '<div class="grid-item product small product-list-marketing-card" data-card-id="' + marketingCard.id + '">'
                    + '<a href="' + marketingCard.details_url + '">'
                    + '<div class="background box-shadow relative">'
                    + '<div class="highlight-container">';
                    marketingHtmlGrid += '</div>'
                    + '<div class="inner">'
                    + '<div class="marketing-card-image">'
                    + '<img class="lazy" data-src="' + marketingCard.image + '" alt="' + (marketingCard.title ? marketingCard.title : (marketingCard.cardable ? (marketingCard.cardable.name ? marketingCard.cardable.name : (marketingCard.cardable.title ? marketingCard.cardable.title : '-')) : '-') ) + '" title="' + (marketingCard.title ? marketingCard.title : (marketingCard.cardable ? (marketingCard.cardable.name ? marketingCard.cardable.name : (marketingCard.cardable.title ? marketingCard.cardable.title : '-')) : '-') ) + '">'
                    + '</div>'
                    + '<div class="marketing-card-content">'
                    + '<p class="alternative-name"></p>';
                    marketingHtmlGrid += '<h4 class="text-outer name-outer">' + (marketingCard.title ? marketingCard.title : (marketingCard.cardable ? (marketingCard.cardable.name ? marketingCard.cardable.name : (marketingCard.cardable.title ? marketingCard.cardable.title : '-')) : '-') ) + '</h4>'
                    + '<div class="text-outer description-outer">'
                    + '<p class="text-inner description">' + marketingCard.description + '</p>'
                    + '</div></div>'
                    marketingHtmlGrid += '</div></div></a>'
                    + '<div class="clearfix relative">' 
                    + '<div class="extra"><i class="actionToggleDashboard material-icons " data-card-id="' + marketingCard.id + '" data-add-url="/myBaumit/ajaxAddCardToDashboard" data-delete-url="/myBaumit/ajaxDeleteCardFromDashboard" data-added-to-dashboard="0"> star_border  </i></div>' 
                    + '</div></div>';

                    $('.grid').append(marketingHtmlGrid);
                }
                let assets = product.assets;
                let all_pdf = '';

                //let productImageSmall = product.image;

                // Re-add this when import is complete for all domains
                let productImagePath = product.image.split('.');
                productImagePath[productImagePath.length - 2] += '_sm';
                let productImageSmall = productImagePath.join('.');


                if (assets.length > 0) {
                    all_pdf = product.all_asset_download_url;
                }

                var htmlGrid = '';
                const categoryParam = ProductAZUI.getCategoryParam(product, ProductAZCommon.filter.category)

                htmlGrid = '<div class="grid-item product small" data-card-id="' + product.card.id + '">'


                    + '<a href="' + product.details_url + ((categoryParam && categoryParam.length > 0) ? '?category=' + categoryParam : '') + '">'
                    + '<div class="background box-shadow relative">'
                    + '<div class="highlight-container">';

                if (product.card.badge_new == 1) {
                    htmlGrid += '<span class="highlight red">' + ((self as any).translations ? (self as any).translations.products_card_badge_new : 'New') + '</span>';
                }
                if (product.card.badge_eco == 1) {
                    htmlGrid += '<span class="highlight green">' + ((self as any).translations ? (self as any).translations.products_card_badge_eco : 'Eco') + '</span>';
                }
                if (product.card.badge_premium == 1) {
                    htmlGrid += '<span class="highlight gold">' + ((self as any).translations ? (self as any).translations.products_card_badge_premium : 'Premium') + '</span>';
                }

                htmlGrid += '</div>'
                    + '<div class="inner">'
                    + '<img class="lazy" data-src="' + productImageSmall + '" alt="' + product.card.image_seo_alt + '" title="' + product.card.image_seo_title + '">'

                    + '<p class="alternative-name'

                if (product.alternative_name) {
                    htmlGrid += ' more-lines mb-1'
                }

                htmlGrid += '">'

                if (product.alternative_name) {
                    htmlGrid += product.alternative_name
                }

                htmlGrid += '</p>'
                    + '<h4 class="text-outer name-outer">' + product.name + '</h4>'
                    + '<div class="text-outer description-outer">'
                    + '<p class="text-inner description">' + product.additional_name + '</p>'
                    + '</div>'
                
                if ((self as any).useProductBenefitsOnProductCards) {
                    htmlGrid += '<ul class="list-benefits">'
                        + (product.product_benefit_1 ? '<li class="benefit">' + product.product_benefit_1 + '</li>' : '')
                        + (product.product_benefit_2 ? '<li class="benefit">' + product.product_benefit_2 + '</li>' : '')
                        + (product.product_benefit_3 ? '<li class="benefit">' + product.product_benefit_3 + '</li>' : '')
                        + '</ul>'
                }

                htmlGrid += '</div></div></a><div class="clearfix relative d-flex gap-1">' + product.card_dashboard_icon_rendered + '<div class="extra sheets">'
                    + '<button class="extra-button material-icons ';

                if (assets.length == 0) {
                    htmlGrid += 'disabled';
                }
                htmlGrid += '">description</button><div class="extra-container box-shadow"><ul>';

                assets.forEach(function (file) {
                    htmlGrid += '<li><i class="material-icons">get_app</i><a rel="noindex nofollow" href="' + file.URL + '" target="_blank">' + file.type_name + '</a></li>';
                });
                if (assets.length > 1) {
                    htmlGrid += '<li><i class="material-icons">get_app</i><a rel="noindex nofollow" href="' + all_pdf + '" target="_blank">' + (self as any).translations.general_download_all + '</a></li>';
                }

                htmlGrid += '</ul></div></div></div></div>';

                $('.grid').append(htmlGrid);
            });

            products.forEach(function (product) {
                if (product.alternative_name) {
                    $('.alternative-name').addClass('more-lines mb-1');
                }
            });

            /*
            try {
                $('.grid.products-az').masonry('destroy');
            }
            catch (ex) { }//silent

            $('.grid.products-az').masonry();

            */
        }

        public static filterRanges(ranges, selectedRange) {
            for (let range in ranges) {
                if (ranges[range] > 0) {
                    $('.filter-item[data-range=' + range.toUpperCase() + ']').fadeIn();
                }
                else {
                    $('.filter-item[data-range=' + range.toUpperCase() + ']').fadeOut();
                }
            }
            $('.filter-item').removeClass('selected');
            if (selectedRange)
                $('.filter-item[data-range="' + selectedRange + '"]').addClass('selected');
            else
                $('.filter-item:first()').addClass('selected');
        }

        // SET TOTAL ITEMS
        public static setTotal(total) {
            $('.counter:not(.search-counter)').text((self as any).translations.products_filter_results + ': ' + total);
        }


        // PRODUCTS PAGING
        public static paginator(lastpage, filter) {

            $('ul.pagination li:not(".fixed")').remove();
            //$('ul.pagination li:last-of-type a').attr('tabindex', lastpage+1);

            for (var i = lastpage; i > 0; i--) {
                $('<li class="page-item" data-attr="' + i + '"><button class="page-link" index="' + i + '">' + i + '</button></li>').insertAfter('ul.pagination li:first-of-type');
                $('.page-link[index="' + i + '"]').parent('li.page-item:not(.fixed):not(.active)').addClass('hidden');
                $('.page-link[index="' + 1 + '"]').parent('li.page-item:not(.fixed)').addClass('first').removeClass('hidden');
                $('.page-link[index="' + lastpage + '"]').parent('li.page-item:not(.fixed)').addClass('last').removeClass('hidden');
            }

            $('li.page-item.active').removeClass('active');

            var prevPrevPage = +filter.page - 1;
            var prevPage = +filter.page;
            var activePage = +filter.page + 1;
            var nextPage = +filter.page + 2;
            var nextNextPage = +filter.page + 3;

            $('ul.pagination li:first-of-type button').attr('index', prevPrevPage);
            $('ul.pagination li:last-of-type button').attr('index', activePage);

            //console.log('activepage: ' + prevPage + ', lastpage: ' + lastpage);

            //console.log(prevPrevPage, prevPage, activePage, nextPage, nextNextPage);

            if (activePage > 2) {
                $('ul.pagination li:first-of-type').removeClass('disabled');
            } else {
                $('ul.pagination li:first-of-type').addClass('disabled');
            }

            if (activePage > 5) {
                $('ul.pagination li:nth-of-type(' + prevPrevPage + ')').addClass('prevDots');
            } else {
                $('ul.pagination li:nth-of-type(' + prevPrevPage + ')').removeClass('prevDots');
            }

            $('ul.pagination li:nth-of-type(' + prevPrevPage + ')').removeClass('hidden');
            $('ul.pagination li:nth-of-type(' + prevPage + ')').removeClass('hidden');
            $('ul.pagination li:nth-of-type(' + activePage + ')').removeClass('hidden').addClass('active');
            $('ul.pagination li:nth-of-type(' + nextPage + ')').removeClass('hidden');
            $('ul.pagination li:nth-of-type(' + nextNextPage + ')').removeClass('hidden');

            if (activePage < (lastpage - 2)) {
                $('ul.pagination li:nth-of-type(' + nextNextPage + ')').addClass('nextDots');
            } else {
                $('ul.pagination li:nth-of-type(' + nextNextPage + ')').removeClass('nextDots');
            }

            if (activePage < (lastpage + 1)) {
                $('ul.pagination li:last-of-type').removeClass('disabled');
            } else {
                $('ul.pagination li:last-of-type').addClass('disabled');
            }
        }

        public static init() {
            window.addEventListener('resize', ProductAZUI.hideMoreInformation);
            //MEGAMENU CLOSE
            $(document).on('click', '.main-menu .submenu-item a', function () {
                $(this).parents('.submenu').removeClass('visible');
                $(this).parents('.menu-item').removeClass('hover');
            });

            //$('.more-informations-container').show();



        }

        // HIDE MORE INFORMATION UNDER 960PX
        public static hideMoreInformation() {
            if ($(window).width() < 960) {
                $('.more-informations-container').addClass('hidden');
            } else {
                $('.more-informations-container').removeClass('hidden');

                if ($('.more-informations').children().length > 0) {
                    $('.more-informations').slick();
                }
            }
        }

        // SHOW MORE INFORMATION
        public static showMoreInformation(informations, view) {
            $('.more-informations-container').hide();
            $('.more-informations').html('');
            $('.more-informations').removeClass('slick-initialized slick-slider');

            var slides = informations.length
            var slidesToShow = 0;

            if (slides >= 4) {
                slidesToShow = 4
            } else {
                slidesToShow = slides;
            }

            if (slides != 0 && view == 'cards') {
                $('.more-informations-container').show();
                informations.forEach(function (information) {
                    $('.more-informations').append(information);
                });

                if (slides >= 4) {
                    $('.more-informations .card-item').each(function (i, e) {
                        var elem = $(e);
                        elem.removeClass('resize');
                    });
                } else {
                    $('.more-informations .card-item').each(function (i, e) {
                        var elem = $(e);
                        elem.addClass('resize');
                    });
                }

                $('.more-informations').slick({
                    dots: false,
                    infinite: true,
                    slidesToShow: slidesToShow,
                    slidesToScroll: 1,
                    rows: 0,
                    responsive: [
                        {
                            breakpoint: 1279,
                            settings: {
                                slidesToShow: 3
                            }
                        }
                    ]
                });

                CardSectionService.cardsHeightFix($('.grid.products-az'));
            }
        }

        public static showProductCategoryData(category){
            if($('.product-category-view-category-data').length>0){
                $('.product-category-view-category-data--title').text(category.name);
                $('.product-category-view-category-data--description').html(category.category_description);
                $('.product-category-view-category-data').removeClass('d-none');
            }
        }
        public static hideProductCategoryData(){
            if($('.product-category-view-category-data').length>0){
                $('.product-category-view-category-data').addClass('d-none');
                $('.product-category-view-category-data--title').text('');
                $('.product-category-view-category-data--description').html('');
            }
            
        }
    }
}
